import { render, staticRenderFns } from "./Contact_admin.vue?vue&type=template&id=3b595104&"
import script from "./Contact_admin.vue?vue&type=script&lang=js&"
export * from "./Contact_admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports